import Moment from "moment-timezone";
Moment.tz.setDefault("UTC");
export default class DateRange {
    /**
     * @param {*} typeId
     * @param {*} dates
     */
    constructor(typeId, dates) {
        this.typeId = typeId;
        this.dates = dates || {
            start: null,
            end: null,
        };
    }

    startDate() {
        let options = DateRange.options();
        var currentDate = Moment();
        switch (this.typeId) {
            case options.THIS_WEEK.id:
                return currentDate.clone().startOf("isoWeek").toDate();
                break;
            case options.THIS_MONTH.id:
                return currentDate.clone().startOf("month").toDate();
                break;
            case options.LAST_30.id:
                return currentDate.clone().subtract(30, "days").toDate();
                break;
            case options.LAST_90.id:
                return currentDate.clone().subtract(90, "days").toDate();
                break;
            case options.CUSTOM.id:
                if (!this.dates.start) {
                    return null;
                }
                return Moment(this.dates.start).toDate();
                break;
            case options.LAST_60.id:
                return currentDate.clone().subtract(60, "days").toDate();
                break;
            default:
                break;
        }
        return null;
    }

    endDate() {
        switch (this.typeId) {
            case 5:
                if (!this.dates.end) {
                    return null;
                }
                return Moment(this.dates.end || null).toDate();
                break;
            default:
                break;
        }
        return null;
    }

    dateRangeLabel() {
        if (!this.valid()) {
            return null;
        }
        if (!this.typeId) {
            return "All Time";
        }
        if (this.startDate() && !this.endDate()) {
            let startDate = Moment(this.startDate());
            return "After " + startDate.format("LL");
        }
        if (this.endDate() && !this.startDate()) {
            let endDate = Moment(this.endDate());
            return "Before " + endDate.format("LL");
        }
        if (this.endDate() && this.startDate()) {
            let startDate = Moment(this.startDate());
            let endDate = Moment(this.endDate());
            return (
                "Between " +
                startDate.format("LL") +
                " and " +
                endDate.format("LL")
            );
        }
        return null;
    }

    label() {
        let _this = this;
        let dateRangeOptions = DateRange.options();
        let selectedOption = Object.values(dateRangeOptions).find(function (
            option
        ) {
            return option.id === _this.typeId;
        });
        if (!selectedOption) {
            return "All Time";
        } else if (5 === selectedOption.id) {
            return this.dateRangeLabel();
        }
        return selectedOption.label;
    }

    valid() {
        if (5 === this.typeId && (!this.startDate() || !this.endDate())) {
            return false;
        }
        return true;
    }

    definition() {
        return {
            typeId: this.typeId,
            dates: this.dates,
        };
    }

    static options() {
        return {
            THIS_WEEK: {
                id: 1,
                label: "This Week",
                value: "this-week",
            },
            THIS_MONTH: {
                id: 2,
                label: "This Month",
                value: "this-month",
            },
            LAST_30: {
                id: 3,
                label: "Last 30 Days",
                value: "30-days",
            },
            LAST_60: {
                id: 6,
                label: "Last 60 Days",
                value: "60-days",
            },
            LAST_90: {
                id: 4,
                label: "Last 90 Days",
                value: "90-days",
            },
            CUSTOM: {
                id: 5,
                label: "Custom",
                value: "custom",
            },
        };
    }
}
